module.exports = __webpack_public_path__ + "static/media/error.f93adfd4.svg";